import { theme } from 'antd';
import { Flex, Popover, Tag, Typography } from 'zui/Antd';

const { Text } = Typography;
const POPOVER_HEIGHT = 363;

/**
 * PopoverTag - Reusable tag with popover showing a list of items.
 *
 * @param {Object} props
 * @param {React.ElementType} props.icon - Icon component for the tag and popover items.
 * @param {number} props.count - Number to display in the tag.
 * @param {string} props.singular - Singular label (e.g. 'device').
 * @param {string} props.plural - Plural label (e.g. 'devices').
 * @param {Array<{ key: string|number, label: string }>} props.items - Items to show in the popover list.
 * @param {string} [props.placement='left'] - Popover placement.
 */
const PopoverTag = ({ icon: Icon, count, singular, plural, items, placement = 'left', renderItem }) => {
	const {
		token: { colorTextDescription }
	} = theme.useToken();

	return (
		<Popover
			content={
				<Flex vertical gap={4} style={{ maxWidth: 280, maxHeight: POPOVER_HEIGHT, overflowY: 'auto' }}>
					{items.map((item) =>
						renderItem ? (
							renderItem(item)
						) : (
							<Flex key={item.key} align='center' gap={6}>
								<Icon color={colorTextDescription} />
								<Text style={{ fontSize: 12 }}>{item.label}</Text>
							</Flex>
						)
					)}
				</Flex>
			}
			title={`${count} ${count === 1 ? singular : plural}`}
			trigger='hover'
			placement={placement}
			overlayStyle={{ zIndex: 1050 }}
		>
			<Tag
				style={{ cursor: 'pointer', margin: 0, userSelect: 'none' }}
				onClick={(e) => e.stopPropagation()}
				onMouseDown={(e) => e.stopPropagation()}
			>
				<Flex align='center' gap={5}>
					<Icon color='currentColor' width={12} height={12} />
					{count} {count === 1 ? singular : plural}
				</Flex>
			</Tag>
		</Popover>
	);
};

export default PopoverTag;
